var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3304_3091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 24,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39434 1.6025L0.0182961 10.7908C0.00164397 10.825 -0.00363298 10.8636 0.00323693 10.901C0.0101068 10.9384 0.0287632 10.9726 0.0564777 10.9986L11.8751 22.3194C11.9087 22.3516 11.9534 22.3695 11.9999 22.3695C12.0464 22.3695 12.0911 22.3516 12.1247 22.3194L23.9433 10.9994C23.9711 10.9733 23.9897 10.9391 23.9966 10.9017C24.0035 10.8643 23.9982 10.8257 23.9815 10.7916L19.6055 1.60321C19.5914 1.57235 19.5687 1.54621 19.5401 1.52791C19.5115 1.50961 19.4782 1.49992 19.4443 1.50001H4.55696C4.52285 1.49959 4.48935 1.50904 4.46049 1.52722C4.43164 1.54541 4.40866 1.57155 4.39434 1.6025Z",
    fill: "#50AF95"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3304_3091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39434 1.6025L0.0182961 10.7908C0.00164397 10.825 -0.00363298 10.8636 0.00323693 10.901C0.0101068 10.9384 0.0287632 10.9726 0.0564777 10.9986L11.8751 22.3194C11.9087 22.3516 11.9534 22.3695 11.9999 22.3695C12.0464 22.3695 12.0911 22.3516 12.1247 22.3194L23.9433 10.9994C23.9711 10.9733 23.9897 10.9391 23.9966 10.9017C24.0035 10.8643 23.9982 10.8257 23.9815 10.7916L19.6055 1.60321C19.5914 1.57235 19.5687 1.54621 19.5401 1.52791C19.5115 1.50961 19.4782 1.49992 19.4443 1.50001H4.55696C4.52285 1.49959 4.48935 1.50904 4.46049 1.52722C4.43164 1.54541 4.40866 1.57155 4.39434 1.6025Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5184 11.7344C13.4336 11.7408 12.9952 11.7669 12.0173 11.7669C11.2395 11.7669 10.6873 11.7436 10.4936 11.7344C7.48784 11.6022 5.24431 11.0792 5.24431 10.453C5.24431 9.82677 7.48784 9.30445 10.4936 9.17015V11.2135C10.6902 11.2276 11.253 11.2609 12.0308 11.2609C12.9641 11.2609 13.4315 11.222 13.5156 11.2142V9.17157C16.515 9.30515 18.7536 9.82818 18.7536 10.453C18.7536 11.0778 16.5157 11.6008 13.5156 11.7337L13.5184 11.7344ZM13.5184 8.96024V7.13176H17.7043V4.34344H6.30774V7.13176H10.4929V8.95953C7.09118 9.11573 4.533 9.78931 4.533 10.5965C4.533 11.4036 7.09118 12.0765 10.4929 12.2334V18.0927H13.5177V12.2313C16.9116 12.0751 19.4656 11.4022 19.4656 10.5958C19.4656 9.78931 16.9138 9.11644 13.5177 8.95953L13.5184 8.96024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: -3,
    y: 11,
    width: 29,
    height: 7,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58727 14.27H7.79727V13.22H7.58727V13.01H6.32727V14.48H7.58727V14.27ZM8.42727 13.01V14.48H8.21727V14.69H8.00727V14.9H7.79727V15.11H6.32727V17H5.69727V12.38H7.79727V12.59H8.00727V12.8H8.21727V13.01H8.42727ZM11.5786 16.37V17H8.84863V12.38H11.5786V13.01H9.47863V14.27H11.1586V14.9H9.47863V16.37H11.5786ZM13.89 14.27H14.1V13.22H13.89V13.01H12.63V14.48H13.89V14.27ZM14.73 13.01V14.48H14.52V14.69H14.31V14.9H14.1V15.11H12.63V17H12V12.38H14.1V12.59H14.31V12.8H14.52V13.01H14.73ZM17.8814 16.37V17H15.1514V12.38H17.8814V13.01H15.7814V14.27H17.4614V14.9H15.7814V16.37H17.8814Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtPpt);
export default __webpack_public_path__ + "static/media/USDT-PPT.1770c2d451991ba588d737b272b12de8.svg";
export { ForwardRef as ReactComponent };